import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';

@Injectable({
  providedIn: 'root'
})

export class VersionService {
  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
  protected kcmssvcURL = this._kcmssvcURL;
  
  constructor(
    private http: HttpClient
  ) { }

  getVersion(): Observable<string> {
    return this.http.get<string>(`${this.kcmssvcURL}/version`);
  }
}
